export const ADD_ROUTE_TO_TREE = 'ROUTER.ADD_ROUTE_TO_TREE';
export const REMOVE_ROUTE_FROM_TREE = 'ROUTER.REMOVE_ROUTE_FROM_TREE';
export const REPLACE_ROUTE_IN_TREE = 'ROUTER.REPLACE_ROUTE_IN_TREE';
